import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PlanUpgradeManager from "./PlanUpgradeManager";

export default function PlanUpgradePage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PlanUpgradeManager />
    </DashboardLayout>
  );
}
